import { render, staticRenderFns } from "./BTableMobileFriendly.vue?vue&type=template&id=0ba2e0bf"
import script from "./BTableMobileFriendly.vue?vue&type=script&lang=js"
export * from "./BTableMobileFriendly.vue?vue&type=script&lang=js"
import style0 from "./BTableMobileFriendly.vue?vue&type=style&index=0&id=0ba2e0bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports